const CSRF_CONTAINER = 'csrfCountryContainer';
const CSRF_CONTENT = 'csrfContent';
const CSRF_SELECT = 'csrfSelect';
const CSRF_CA_OPTION = 'csrfCAOption';
const CSRF_GB_OPTION = 'csrfGBOption';
const CSRF_US_OPTION = 'csrfUSOption';

export {
  CSRF_CONTAINER,
  CSRF_CONTENT,
  CSRF_SELECT,
  CSRF_CA_OPTION,
  CSRF_GB_OPTION,
  CSRF_US_OPTION,
};
